import React, { Fragment } from 'react';
import styled from 'styled-components';
import I10n from '../../features/i10n';
import Button from '../../atoms/button';
import { SECONDARY_COLOR } from '../../color-constants';
import MsxIcons from '../../features/msx-icons';
import ProductLink from '../product_link';
import DropdownMenu from '../dropdown_menu';
import InformationIcon from '../../atoms/information-icon';

const StickyHeader = styled.div`
  position: absolute;
  z-index: 3;
  top: 20px;
  left: 10px;
  right: 10px;
  overflow: hidden;
  pointer-events: none;
`;

const OverflowWrapper = styled.div`
  position: relative;
  display: flex;
  padding: 20px 10px;
  border-radius: 8px;
  background-color: white;
  overflow: hidden;

  @media (max-width: 800px) {
    display: none;
  }
`;

const ComparatorWrapper = styled.div`
  display: flex;
  flex: 1 1 0px;
  overflow: auto;
`;

const ComparatorTable = styled.table`
  min-width: 100%;
  max-width: 100%;
`;

const ComparatorHeader = styled.thead``;

const ComparatorBody = styled.tbody``;

const ComparatorTableHeaderRow = styled.tr`
  td:first-child {
    position: sticky;
    z-index: 1;
    left: 0;
  }
`;

const ComparatorHeaderCell = styled.th`
  ${props => props.width ? `
    min-width: ${props.width}%;
    width: ${props.width}%;
    max-width: ${props.width}%;
  ` : ''}
`;

const ComparatorTableRow = styled.tr`
  background-color: white;
  td:first-child {
    position: sticky;
    z-index: 1;
    left: 0;
    background-color: white;
  }
  ${props => props.$hideRow ? `visibility: hidden;` : ''}
  ${props => props.$resetPointerEvents ? `pointer-events: auto;` : ''}
`;

const ComparatorItemRow = styled.tr`
  border-bottom: 1px solid #D9D9D9;
  td:first-child {
    position: sticky;
    z-index: 1;
    left: 0;
  }
  ${props => props.$hideRow ? `visibility: hidden; border-bottom: 0px;`: ''}
  ${props => props.$resetPointerEvents ? `pointer-events: auto;` : ''}
`;

const ComparatorTableCell = styled.td`
  vertical-align: middle;
`;

const ComparatorTableValueCell = styled(ComparatorTableCell)`
  background-color: #F4F4F4;
`;

const ComparatorGroupTitleCell = styled(ComparatorTableCell)`
  white-space: nowrap;
`;

const ComparatorGroupTitleCellContent = styled.div`
  padding: 10px 0px;
`;

const ComparatorTableCellContent = styled.div`
  padding: 10px;
`;

const CenteredComparatorTableCellContent = styled(ComparatorTableCellContent)`
  display: flex;
  justify-content: center;
  align-items: center;
  white-space: pre-wrap;
  text-align: center;
`;

const PreferredChip = styled.span`
  font-size: 14px;
  font-weight: 400;
  background-color: #CCF1FF;
  color: #005B80;
  padding: 5px 10px;
  border-radius: 9999px;
`;

const ComparatorTitle = styled.span`
  font-size: 24px;
  font-weight: 700;
`;

const ComparatorValueGroupTitle = styled.span`
  font-size: 16px;
  font-weight: 700;
  white-space: pre-wrap;
`;

const ComparatorItemLabel = styled.span`
  font-size: 16px;
  font-weight: 400;
`;

const ComparatorIconWrapper = styled.div`
  min-width: 32px;
  width: 32px;
  max-width: 32px;
  min-height: 32px;
  height: 32px;
  max-height: 32px;
  color: ${SECONDARY_COLOR};
  color: var(--se-primary, ${SECONDARY_COLOR});
`;

const HintIcon = styled.span`
  display: inline-block;
  margin-left: 5px;
  color: #6D6F75;
  cursor: pointer;
`;

const HintDropdownWrapper = styled.div`
  width: 200px;
  position: relative;
  padding: 15px;
  font-size: 14px;
  white-space: pre-wrap;
`;

const COMPARATOR_VALUE_TYPES = {
  TEXT: 'text',
  ICON: 'icon',
  NUMERIC: 'numeric'
};

const VALUE_ICON_MAPPING = {
  CHECK: 'check'
};

let componentId = 0;

class LicenseComparatorTable extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      componentId: componentId++
    }
  }

  handleVerticalScroll () {
    const headerDemarcation = document.getElementById(`${this.props.licenseSubGroup.displayGroupKey}-${this.state.componentId}-sticky-header-demarcation`);
    const positionerElement = document.getElementById(`${this.props.licenseSubGroup.displayGroupKey}-${this.state.componentId}-absolute`);
      if (positionerElement) {
        if (this._verticalScrollDiv && this._overflowElement &&  this._verticalScrollDiv.scrollTop > (this._overflowElement.offsetTop + 20)) {
          let newTopPosition = this._verticalScrollDiv.scrollTop - this._overflowElement.offsetTop;
          if (headerDemarcation) {
            const positionerBounding = positionerElement.getBoundingClientRect();
            newTopPosition = (Math.min(newTopPosition, (positionerBounding.height - 20) - headerDemarcation.offsetTop));
          }
          positionerElement.style.top = `${newTopPosition}px`;
        } else {
          positionerElement.style.top = '20px';
        }
      }
  }

  handleHorizontalScroll () {
    const positionerElement = document.getElementById(`${this.props.licenseSubGroup.displayGroupKey}-${this.state.componentId}-absolute`);
    if (positionerElement) {
      positionerElement.style.left = `${(-this._boundingElement.scrollLeft) + 10}px`;
    }
  }

  componentDidMount() {
    this._verticalScrollDiv = document.getElementById('slc-license-groups-scrollable-wrapper');
    if (this._verticalScrollDiv && this._boundingElement) {
      this._verticalScrollFunction = () => {
        this.handleVerticalScroll();
      };

      this._horizontalScrollFunction = () => {
        this.handleHorizontalScroll();
      };

      this._screenResizeFunction = () => {
        this.handleVerticalScroll();
        this.handleHorizontalScroll();
      }

      this._verticalScrollDiv.addEventListener("scroll", this._verticalScrollFunction);
      this._boundingElement.addEventListener("scroll", this._horizontalScrollFunction);
      window.addEventListener("resize", this._screenResizeFunction);
    }
  }

  componentWillUnmount() {
    if (this._verticalScrollDiv) {
      this._verticalScrollDiv.removeEventListener("scroll", this._verticalScrollFunction)
    }
    if (this._boundingElement) {
      this._boundingElement.removeEventListener("scroll", this._horizontalScrollFunction);
    }
    window.removeEventListener("resize", this._screenResizeFunction);
  }

  renderComparatorPreferredRow(licenseSubGroup) {
    return (
      <ComparatorTableRow $resetPointerEvents={true}>
        <ComparatorTableCell></ComparatorTableCell>
        {licenseSubGroup.comparatorTypes.map((comparatorType, idx) => {
          return (<ComparatorTableCell key={idx}>
            {comparatorType.preferred && <CenteredComparatorTableCellContent>
              <PreferredChip>{I10n.get('screen.licence_selector.preferred')}</PreferredChip>
            </CenteredComparatorTableCellContent>}
        </ComparatorTableCell>); })}
      </ComparatorTableRow>
    );
  }

  renderComparatorTitleRow(licenseSubGroup) {
    return (
      <ComparatorTableRow $resetPointerEvents={true}>
        <ComparatorTableCell></ComparatorTableCell>
        {licenseSubGroup.comparatorTypes.map((comparatorType, idx) => {
          return (<ComparatorTableCell key={idx}>
            <CenteredComparatorTableCellContent>
              <ComparatorTitle>{I10n.getOrDefault(`screen.licence_selector.comparator_type.name.${comparatorType.labelKey}`, comparatorType.comparatorTypeName)}</ComparatorTitle>
            </CenteredComparatorTableCellContent>
        </ComparatorTableCell>); })}
      </ComparatorTableRow>
    );

  }

  renderComparatorConfigureButtonRow(licenseSubGroup) {
    return (
      <ComparatorTableRow $resetPointerEvents={true}>
        <ComparatorTableCell></ComparatorTableCell>
        {licenseSubGroup.comparatorTypes.map((comparatorType, idx) => {
          return (<ComparatorTableCell key={idx}>
            <CenteredComparatorTableCellContent>
              {comparatorType.licenseTypesKey && <Button importance="emphasized" disabled={this.props.isSaving} onClick={() => {
                this.props.onAddSoftwareLicencesRequested(comparatorType);
              }}>
                {I10n.getOrDefault(`screen.licence_selector.configure_and_buy.${this.props.softwareSelection}`, I10n.get('screen.licence_selector.configure_and_buy'))}
              </Button>}
            </CenteredComparatorTableCellContent>
        </ComparatorTableCell>); })}
      </ComparatorTableRow>
    );
  }

  renderComparatorKnowMoreRow(licenseSubGroup) {
    return (
      <ComparatorTableRow $resetPointerEvents={true}>
        <ComparatorTableCell></ComparatorTableCell>
        {licenseSubGroup.comparatorTypes.map((comparatorType, idx) => {
          return (<ComparatorTableCell key={idx}>
            {this.props.knowMoreLinksMap[comparatorType.scopedKnowMoreReferences[0].id] && <CenteredComparatorTableCellContent>
              <ProductLink fullLink={this.props.knowMoreLinksMap[comparatorType.scopedKnowMoreReferences[0].id]} label={I10n.get('screen.licence_selector.know_more')}></ProductLink>
            </CenteredComparatorTableCellContent>}
        </ComparatorTableCell>); })}
      </ComparatorTableRow>
    );
  }

  renderValueIcon(value) {
    let renderFunction = () => <ComparatorItemLabel>ERR</ComparatorItemLabel>;
    const mapTypeToRenderFunction = {
      [VALUE_ICON_MAPPING.CHECK]: () => {
        return <ComparatorIconWrapper>
          <MsxIcons name="done-stroke" size="medium"></MsxIcons>
        </ComparatorIconWrapper>;
      }
    }

    if (mapTypeToRenderFunction[value]) {
      renderFunction = mapTypeToRenderFunction[value];
    }

    return renderFunction();
  }

  renderComparatorItemValue(comparatorItem) {
    let renderFunction = () => <ComparatorItemLabel>ERR</ComparatorItemLabel>;
    const mapTypeToRenderFunction = {
      [COMPARATOR_VALUE_TYPES.TEXT]: () => {
        return <ComparatorItemLabel>{I10n.getOrDefault(`screen.licence_selector.comparator_value.name.${comparatorItem.labelKey}`, comparatorItem.value)}</ComparatorItemLabel>;
      },
      [COMPARATOR_VALUE_TYPES.ICON]: () => {
        return this.renderValueIcon(comparatorItem.value);
      },
      [COMPARATOR_VALUE_TYPES.NUMERIC]: () => {
        return <ComparatorItemLabel>{comparatorItem.value}</ComparatorItemLabel>;
      }
    }

    if (mapTypeToRenderFunction[comparatorItem?.type]) {
      renderFunction = mapTypeToRenderFunction[comparatorItem.type];
    }

    return renderFunction();
  }

  renderComparatorValueGroup(comparatorValueGroup, comparatorTypes, hideRow) {
    return (
      <>
        <ComparatorTableRow $hideRow={hideRow}>
          <ComparatorGroupTitleCell>
            <ComparatorGroupTitleCellContent>
              <ComparatorValueGroupTitle>{I10n.getOrDefault(`screen.licence_selector.comparator_group.name.${comparatorValueGroup.labelKey}`, comparatorValueGroup.comparatorGroupName)}</ComparatorValueGroupTitle>
            </ComparatorGroupTitleCellContent>
          </ComparatorGroupTitleCell>
        </ComparatorTableRow>
        {comparatorValueGroup.comparatorItems.map((comparatorItem, idx) => {
          return (
            <ComparatorItemRow key={idx} $hideRow={hideRow}>
              <ComparatorTableValueCell>
                <ComparatorTableCellContent>
                  <ComparatorItemLabel>
                    {I10n.getOrDefault(`screen.licence_selector.comparator_item.name.${comparatorItem.labelKey}`, comparatorItem.comparatorItemName)}
                  </ComparatorItemLabel>
                </ComparatorTableCellContent>
              </ComparatorTableValueCell>
              {comparatorTypes.map((comparatorType, idx) => {
                const comparatorValue = comparatorType?.comparatorValues?.[comparatorItem.comparatorItemKey];
                return (
                  <ComparatorTableValueCell key={idx}>
                    <CenteredComparatorTableCellContent>
                      {this.renderComparatorItemValue(comparatorValue)}
                      {comparatorValue?.hint &&
                        <DropdownMenu
                          data-clickable
                          toggleElement={<HintIcon>
                            <InformationIcon size="small"></InformationIcon>
                          </HintIcon>}
                          containerElement={
                            <HintDropdownWrapper>{I10n.getOrDefault(`screen.licence_selector.comparator_value.name.${comparatorValue.labelKey}.hint`, comparatorValue.hint)}</HintDropdownWrapper>
                          }
                          allowTop={true}
                          boundingElement={this._boundingElement}
                        ></DropdownMenu>}
                    </CenteredComparatorTableCellContent>
                  </ComparatorTableValueCell>
                );
              })}
            </ComparatorItemRow>
          );
        })}
      </>
    );
  }

  renderComparatorTable (licenseSubGroup, headerElements, hideBody) {
    return (
      <ComparatorTable>
        <ComparatorHeader>
          <ComparatorTableHeaderRow>
            {headerElements.map((elt, idx) => {
              return (
                <Fragment key={idx}>
                  {elt}
                </Fragment>
              );
            })}
          </ComparatorTableHeaderRow>
        </ComparatorHeader>
        <ComparatorBody>
          {this.renderComparatorPreferredRow(licenseSubGroup)}
          {this.renderComparatorTitleRow(licenseSubGroup)}
          {this.renderComparatorConfigureButtonRow(licenseSubGroup)}
          {this.renderComparatorKnowMoreRow(licenseSubGroup)}
          {hideBody && <tr id={`${this.props.licenseSubGroup.displayGroupKey}-${this.state.componentId}-sticky-header-demarcation`}></tr>}
          {licenseSubGroup.comparatorGroups.map((comparatorValueGroup, idx) => {
            return (
              <Fragment key={idx}>
                {this.renderComparatorValueGroup(comparatorValueGroup, licenseSubGroup.comparatorTypes, hideBody)}
              </Fragment>
            );
          })}

        </ComparatorBody>
      </ComparatorTable>
    );
  }

  render() {
    const {
      licenseSubGroup
    } = this.props;

    const id = `${this.props.licenseSubGroup.displayGroupKey}-${this.state.componentId}-absolute`;
    const nbColumns = (licenseSubGroup.comparatorTypes.length + 1);
    const headerElements = [<ComparatorHeaderCell width={100.0 / nbColumns}></ComparatorHeaderCell>];
    licenseSubGroup.comparatorTypes.forEach(() => {
      headerElements.push(<ComparatorHeaderCell width={100.0 / nbColumns}></ComparatorHeaderCell>);
    });

    return (
      <OverflowWrapper ref={(element) => { this._overflowElement = element }}>
        <StickyHeader id={id}>
          {this.renderComparatorTable(licenseSubGroup, headerElements, true)}
        </StickyHeader>
        <ComparatorWrapper ref={(element) => { this._boundingElement = element }}>
          {this.renderComparatorTable(licenseSubGroup, headerElements, false)}
        </ComparatorWrapper>
      </OverflowWrapper>
    );
  }
}

export default LicenseComparatorTable;
